/**
 * Dentis Rebuy Add-on Product Filter
 * Manages which add-on products are visible based on selected variant
 * 
 * Works with both modern and legacy Rebuy templates
 */

(function() {
  'use strict';

  // Variant to Product Index Mapping
  const VARIANT_PRODUCT_MAP = {
    41872561602649: 0, // Single Black -> Product 0
    41872561635417: 1, // Single White -> Product 1
    41912386027609: 2  // Duo Pack -> Product 2
  };

  // Track if initial sync has been completed
  let hasInitialSyncCompleted = false;

  /**
   * Update visible Rebuy products based on variant
   * @param {number} variantId - Variant ID to display product for
   */
  function updateRebuyProducts(variantId) {
    console.log('[Dentis Rebuy] Updating for variant:', variantId);

    // Get target product index
    const targetIndex = VARIANT_PRODUCT_MAP[variantId];
    
    if (targetIndex === undefined) {
      console.warn('[Dentis Rebuy] No mapping found for variant:', variantId);
      return;
    }

    // Handle Modern Template (card-based design)
    updateModernTemplate(targetIndex);
    
    // Handle Legacy Template (horizontal layout)
    updateLegacyTemplate(targetIndex, variantId);
  }

  /**
   * Get variant ID from URL query parameter
   * @returns {number|null} - Variant ID from URL or null if not found
   */
  function getVariantFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantParam = urlParams.get('variant');
    return variantParam ? parseInt(variantParam) : null;
  }

  /**
   * Handle variant change from DOM
   * Gets variant ID from the event and calls updateRebuyProducts
   * @param {Event} e - Event object (optional)
   * @param {boolean} isInitialLoad - Whether this is the first load
   */
  function handleVariantChange(e, isInitialLoad = false) {
    let variantId;

    if (e && e.detail && e.detail.variant) {
      variantId = e.detail.variant.id;
      console.log('[Dentis Rebuy] Variant changed via event to:', variantId);
    } else {
      // On initial load, prioritize URL parameter
      if (isInitialLoad) {
        const urlVariant = getVariantFromUrl();
        if (urlVariant) {
          variantId = urlVariant;
          console.log('[Dentis Rebuy] Using variant from URL parameter:', variantId);
        }
      }
      
      // Get initial variant on page load from DOM (if not from URL)
      if (!variantId) {
        const selectedInput = document.querySelector('input[name="id"]:checked') || 
                             document.querySelector('select[name="id"]');
        variantId = selectedInput ? parseInt(selectedInput.value) : null;
      }
      
      // Fallback to ProductJSON if DOM not ready yet
      if (!variantId) {
        const productJsonScript = document.querySelector('script[type="application/json"][id*="ProductJSON"]');
        if (productJsonScript) {
          try {
            const variants = JSON.parse(productJsonScript.textContent);
            // Get first available variant
            const firstAvailable = variants.find(v => v.available) || variants[0];
            variantId = firstAvailable?.id;
            console.log('[Dentis Rebuy] Got variant from ProductJSON:', variantId);
          } catch(e) {
            console.warn('[Dentis Rebuy] Could not parse ProductJSON');
          }
        }
      }
      
      // Final fallback to variant-radios
      if (!variantId) {
        const variantRadios = document.querySelector('variant-radios');
        if (variantRadios) {
          const variantData = variantRadios.querySelector('script[type="application/json"]');
          if (variantData) {
            try {
              const variants = JSON.parse(variantData.textContent);
              const firstAvailable = variants.find(v => v.available) || variants[0];
              variantId = firstAvailable?.id;
              console.log('[Dentis Rebuy] Got variant from variant-radios:', variantId);
            } catch(e) {
              console.warn('[Dentis Rebuy] Could not parse variant data');
            }
          }
        }
      }
      
      console.log('[Dentis Rebuy] First or selected available variant ID:', variantId);
    }

    if (variantId) {
      updateRebuyProducts(variantId);
      
      // Mark initial sync as completed after first successful update
      if (isInitialLoad) {
        hasInitialSyncCompleted = true;
      }
    }
  }

  /**
   * Select a product by triggering a click on its card
   * This respects Vue's reactivity and Rebuy's internal state
   * @param {number} targetIndex - Product index to select
   */
  function selectProduct(targetIndex) {
    // Small delay to ensure DOM is fully rendered
    setTimeout(() => {
      const widget = document.querySelector('#rebuy-widget-180126');
      if (!widget) {
        console.warn('[Select Product] Widget element not found');
        return;
      }
      
      const productCards = widget.querySelectorAll('.rebuy-addon-card:not(.rebuy-addon-decline)');
      
      if (productCards.length === 0) {
        console.warn('[Select Product] No product cards found');
        return;
      }
      
      if (productCards[targetIndex]) {
        // Check if it's already selected to avoid unnecessary clicks
        if (!productCards[targetIndex].classList.contains('is-selected')) {
          console.log('[Select Product] Triggering click on product at index:', targetIndex);
          productCards[targetIndex].click();
        } else {
          console.log('[Select Product] Product at index', targetIndex, 'already selected');
        }
      } else {
        console.warn('[Select Product] Product card at index', targetIndex, 'not found');
      }
    }, 150); // Small delay to ensure widget is rendered
  }

  /**
   * Update modern template products
   */
  function updateModernTemplate(targetIndex) {
    const widget = document.querySelector('#rebuy-widget-180126');
    if (!widget) return;

    const productCards = widget.querySelectorAll('.rebuy-addon-card:not(.rebuy-addon-decline)');
    if (productCards.length === 0) return;

    console.log('[Modern Template] Showing product index:', targetIndex);

    // Show only the target product, hide others
    productCards.forEach((card, index) => {
      if (index === targetIndex) {
        card.style.display = 'block';
      } else {
        card.style.display = 'none';
      }
    });

    // Select the visible product (with retry mechanism)
    selectProduct(targetIndex);
  }

  /**
   * Update legacy template products
   */
  function updateLegacyTemplate(targetIndex, variantId) {
    const rebuyItems = document.querySelectorAll('#rebuy-widget-180126 .rebuy-addon__item');
    if (rebuyItems.length === 0) return;

    console.log('[Legacy Template] Showing product index:', targetIndex);

    // Hide all items and uncheck
    rebuyItems.forEach((item, index) => {
      item.classList.remove('show');
      item.style.display = 'none';
      const checkbox = item.querySelector('.rebuy-checkbox');
      if (checkbox) {
        checkbox.checked = false;
      }
    });

    // Show the target item
    if (rebuyItems[targetIndex]) {
      rebuyItems[targetIndex].classList.add('show');
      rebuyItems[targetIndex].style.display = 'flex';
    }

    // Clear Rebuy selections
    if (window.Rebuy && window.Rebuy.widgets) {
      const rebuyWidget = window.Rebuy.widgets.find(w => w.id === "180126");
      if (rebuyWidget && rebuyWidget.data && rebuyWidget.data.products) {
        rebuyWidget.data.products.forEach(product => {
          if (product.selected) {
            rebuyWidget.toggleProductSelect(product);
          }
        });
      }
    }
  }

  /**
   * Setup click handlers for legacy template
   */
  function setupLegacyClickHandlers() {
    const productContainers = document.querySelectorAll('#rebuy-widget-180126 .rebuy-addon__item');
    
    productContainers.forEach(container => {
      const checkbox = container.querySelector('.rebuy-checkbox');
      if (!checkbox) return;
      
      // Prevent checkbox clicks from bubbling
      checkbox.addEventListener('click', (event) => {
        event.stopPropagation();
      });

      // Make container clickable to toggle checkbox
      container.addEventListener('click', () => {
        checkbox.click();
      });

      // Handle title clicks for learn more links
      const titleElement = container.querySelector('.rebuy-addon__item-product-title');
      const learnMoreLink = container.querySelector('.rebuy-addon__item-learn-more-link');

      if (titleElement && learnMoreLink) {
        const url = learnMoreLink.href;
        titleElement.addEventListener('click', (event) => {
          event.stopPropagation();
          window.open(url, '_blank');
        });
      }
    });
  }

  /**
   * NOTE: Manual cart add logic removed!
   * 
   * Rebuy product-addon widgets automatically add selected products to cart
   * when the main product is added. We only need to:
   * 1. Manage which addon products are visible (based on variant)
   * 2. Maintain selection state
   * 
   * Rebuy handles the rest automatically!
   */

  // Export for Rebuy callbacks or manual calls
  window.dentisRebuyUpdateProducts = function() {
    console.log('[Dentis Rebuy] Manual update triggered');
    

    // If initial sync hasn't completed yet, treat this as initial load
    // This handles the case where Rebuy's ready callback fires before our init
    if (!hasInitialSyncCompleted) {
      console.log('[Dentis Rebuy] Initial sync not completed, checking URL parameter');
      handleVariantChange(null, true);
    } else {
      handleVariantChange();
    }
  };

  // Initialize on DOM ready
  function init() {
    console.log('════════════════════════════════════');
    console.log('[Dentis Rebuy] INITIALIZING...');
    console.log('════════════════════════════════════');
    
    // Listen for variant change event that bubbles up to body
    document.body.addEventListener('change', function(e) {
      if (e.target.matches('input[name="id"]') || e.target.matches('select[name="id"]')) {
        console.log('[Dentis Rebuy] 🔄 Variant input changed:', e.target.value);
        handleVariantChange({ detail: { variant: { id: parseInt(e.target.value) } } });
      }
    }, true); // Use capturing to catch events early

    // Listen for Shopify's variant change event
    document.addEventListener('variant:changed', function(e) {
      console.log('[Dentis Rebuy] 🔄 variant:changed event detected');
      if (e.detail && e.detail.variant) {
        handleVariantChange({ detail: { variant: e.detail.variant } });
      }
    });

    // Listen for main product form submit to flag expected cart updates
    // This prevents the cart from opening on initial page load/Rebuy init
    let isExpectingCartUpdate = false;
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      productForm.addEventListener('submit', function() {
        console.log('[Dentis Rebuy] Main product submit detected - enabling cart refresh');
        isExpectingCartUpdate = true;
        // Auto-reset flag after 3s to prevent stuck state
        setTimeout(() => { isExpectingCartUpdate = false; }, 3000);
      });
    }

    // Listen for Rebuy cart changes to trigger theme drawer refresh (Debounced)
    let refreshDebounce;
    document.addEventListener('rebuy:cart.change', function(e) {
      if (isExpectingCartUpdate) {
        clearTimeout(refreshDebounce);
        refreshDebounce = setTimeout(() => {
          console.log('[Dentis Rebuy] 🛒 Rebuy cart change detected AND expected - triggering theme refresh');
          document.dispatchEvent(new Event('rebuy:product:add'));
          isExpectingCartUpdate = false; // Reset flag
        }, 300);
      } else {
        console.log('[Dentis Rebuy] ℹ️ Rebuy cart change ignored (not triggered by user add)');
      }
    });
    
    /**
     * Rebuy product-addon widgets automatically handle cart additions!
     * When a selected addon product is in the widget and the main product 
     * is added to cart, Rebuy automatically adds the selected addon.
     * 
     * We don't need manual cart logic - just maintain:
     * - Which products are visible (variant-aware filtering)
     * - Which product is selected (auto-select on variant change)
     */
    console.log('[Dentis Rebuy] ℹ️ Relying on Rebuy\'s built-in addon cart functionality');
    
    // Initial update on page load - longer delay to ensure DOM is ready
    setTimeout(() => {
      console.log('[Dentis Rebuy] 🎬 Running initial setup...');
      handleVariantChange(null, true); // Pass true for isInitialLoad
      setupLegacyClickHandlers();
    }, 800);
  }

  // Run initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

